<div class="main">
  <section class="container">
    <div class="row">
      <div class="col-12">
        <h2>{{ "HELPFUL_TOOLS" | translate }}</h2>
        <hr aria-hidden="true" />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-12 mt-5">
        <div
          class="card shadow-none card-bg card-role"
          *ngIf="settingsStrumentiUtili.userRoles"
        >
          <div class="card-body card-body-custom">
            <div class="d-flex align-items-center">
              <div class="mx-2">
                <h3 class="card-title">
                  {{ settingsStrumentiUtili.cardTitle! | translate }}
                </h3>
                <div class="card-description">
                  {{ settingsStrumentiUtili.cardBody! | translate }}
                </div>
              </div>
              <button
                type="button"
                class="btn btn-link link-md btn-download"
                (click)="downloadFile()"
                title="{{
                  settingsStrumentiUtili.titleDownloadBtn! | translate
                }}"
                [attr.aria-label]="
                  settingsStrumentiUtili.titleDownloadBtn! | translate
                "
              >
                <svg aria-hidden="true" class="icon icon-primary">
                  <use
                    href="assets/bootstrap-italia.svg#it-download"
                  ></use></svg
                >{{ "DOWNLOAD" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12 mt-2 d-flex justify-content-center">
        <img alt="" src="assets/strumenti-utili.svg" />
      </div>
    </div>
  </section>
</div>
